import { render } from "./gradientPlay.vue?vue&type=template&id=39813ae7"
import script from "./gradientPlay.vue?vue&type=script&lang=js"
export * from "./gradientPlay.vue?vue&type=script&lang=js"

import "./gradientPlay.vue?vue&type=style&index=0&id=39813ae7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__